export const create = {
  createSuccessfully: 'Create new washing machine part successfully!',
}
